import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-mt-2" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_TokenItem = _resolveComponent("TokenItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.user_tokens)
        ? (_openBlock(), _createBlock(_component_Dropdown, {
            key: 0,
            modelValue: _ctx.tag_filter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tag_filter) = $event)),
            options: _ctx.tag_filter_options,
            optionLabel: "name"
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Paginator, {
        first: _ctx.offset,
        "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.offset) = $event)),
        rows: _ctx.limit,
        pageLinkSize: 3,
        totalRecords: _ctx.total_records,
        alwaysShow: false,
        class: "p-p-0"
      }, {
        FirstPageLink: _withCtx(() => []),
        _: 1
      }, 8, ["first", "rows", "totalRecords"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page_tokens, (token) => {
      return (_openBlock(), _createBlock(_component_TokenItem, {
        key: token.name,
        token: token,
        selected: token.asset_contract.address == _ctx.selected_asset_contract_address && token.token_id == _ctx.selected_token_id,
        in_playlist: _ctx.playlist_tokens.some(t => t.asset_contract_address == token.asset_contract.address && t.token_id == token.token_id),
        onClick: ($event: any) => (_ctx.selectToken(token.asset_contract.address, token.token_id)),
        onTogglePlaylistToken: ($event: any) => (_ctx.togglePlaylistToken(token, $event))
      }, null, 8, ["token", "selected", "in_playlist", "onClick", "onTogglePlaylistToken"]))
    }), 128))
  ]))
}